export enum SeverityLevel {
    Error = 'Error',
    Query = 'Query',
    Warning = 'Warning',
    Info = 'Info'
}
